import StudentLayout from "../components/StudentLayout";

import Home from "../pages/student/Home";

import Courses from "../pages/student/Courses";

import CourseDetail from "../pages/student/CourseDetail";

import MyCourses from "../pages/student/MyCourses";

import Wallet from "../pages/student/Wallet";

import Profile from "../pages/student/Profile";

import ExamTake from "../pages/student/ExamTake";

import TeacherProfile from "../pages/student/TeacherProfile";

import Notifications from "../pages/student/Notifications";

import LessonViewer from "../pages/student/LessonViewer";

import Certificates from "../pages/student/Certificates";

import UpdatePassword from "../pages/account_pages/UpdatePassword";

import Paths from "../pages/student/Paths";

import PathDetail from "../pages/student/PathDetail";

import CertificateVerify from "../pages/student/CertificateVerify";

import Verify from "../pages/auth _pages/Verify";

import Onboarding from "../pages/auth _pages/Onboarding";



function wrap(element) {

    return <StudentLayout>{element}</StudentLayout>;

}



function StudentRoutes() {

    return [

        { path: '/home', element: wrap(<Home />) },

        { path: '/courses', element: wrap(<Courses />) },

        { path: '/courses/:id', element: wrap(<CourseDetail />) },

        { path: '/my-courses', element: wrap(<MyCourses />), authRequired: true },

        { path: '/wallet', element: wrap(<Wallet />), authRequired: true },

        { path: '/profile', element: wrap(<Profile />), authRequired: true },

        { path: '/certificates', element: wrap(<Certificates />), authRequired: true },

        { path: '/update-password', element: wrap(<UpdatePassword />), authRequired: true },

        { path: '/paths', element: wrap(<Paths />) },

        { path: '/paths/:id', element: wrap(<PathDetail />) },

        { path: '/verify-certificate', element: wrap(<CertificateVerify />) },

        { path: '/course/:courseId/exam/:examId', element: wrap(<ExamTake />), authRequired: true },

        { path: '/teachers/:id', element: wrap(<TeacherProfile />) },

        { path: '/notifications', element: wrap(<Notifications />), authRequired: true },

        { path: '/courses/:courseId/lesson/:fileId', element: wrap(<LessonViewer />), authRequired: true },

        { path: '/verify', element: <Verify />, authRequired: true },

        { path: '/onboarding', element: <Onboarding />, authRequired: true },

    ];

}



export default StudentRoutes;

